import React from 'react';
import ButtonMUI from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

export default function Button(props) {
  const borderRadiusSize = props.squared ? '7px' : '23px';

  const useStyles = makeStyles({
    root: {
      textTransform: 'none',
      height: props.height,
      width: props.width,
      background: props.backgroundGradient ? props.backgroundGradient : 'auto',
      maxWidth: props.maxWidth,
    },
    outlined: {
      border: 'solid 2px',
      '&:hover': {
        border: 'solid 2px',
      },
      color: props.outlinedColor,
      borderColor: props.outlinedBorderColor,
    },
    containedPrimary: {
      borderRadius: borderRadiusSize,
      color: 'white',
    },
    outlinedPrimary: { borderRadius: borderRadiusSize },
    textPrimary: { borderRadius: borderRadiusSize },
  });
  const classes = useStyles();
  return (
    <ButtonMUI
      disableElevation
      variant="contained"
      color="primary"
      {...props}
      squared={undefined} //MUI button doesn't use this prop
      // https://material-ui.com/api/button/#css
      classes={{
        ...classes,
      }}
    >
      {props.children}
    </ButtonMUI>
  );
}
Button.defaultProps = {
  variant: 'contained',
};

Button.propTypes = {
  disableElevation: PropTypes.bool,
  /**
   * Button variation
   */
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  /**
   * Text color
   */
  color: PropTypes.string,
  /**
   * Background gradient
   */
  backgroundGradient: PropTypes.string,
};
